/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ArchiveWorkOrdersDto,
  ArchiveWorkOrdersResultDto,
  BatchAddWorkOrdersDto,
  BatchRemoveWorkOrdersDto,
  BatchUpdateWorkOrdersDto,
  ConfirmProductWorkloadCategoryDto,
  CreateProjectPlanningDto,
  ProjectPlanningControllerGetProjectPlanningParams,
  ProjectPlanningControllerListProjectsPlanningParams,
  ProjectPlanningDetailDto,
  ProjectPlanningListItemDto,
  ProjectWorkOrderDetailDto,
  ReleaseProjectDto,
  UnarchiveWorkOrdersDto,
  UnarchiveWorkOrdersResultDto,
  UpdateProjectColumnConfigDto,
  UpdateProjectPlanningDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns all non-archived projects for the given partner with planning status (draft/released), distinct factory names, and work order counts. Ordered by creation date descending. Callers must be a member of the requested partner (admins bypass this check).
 * @summary List projects for a partner with planning info
 */
export type projectPlanningControllerListProjectsPlanningResponse200 = {
  data: ProjectPlanningListItemDto[]
  status: 200
}

export type projectPlanningControllerListProjectsPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerListProjectsPlanningResponse403 = {
  data: void
  status: 403
}
    
export type projectPlanningControllerListProjectsPlanningResponseSuccess = (projectPlanningControllerListProjectsPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerListProjectsPlanningResponseError = (projectPlanningControllerListProjectsPlanningResponse401 | projectPlanningControllerListProjectsPlanningResponse403) & {
  headers: Headers;
};

export type projectPlanningControllerListProjectsPlanningResponse = (projectPlanningControllerListProjectsPlanningResponseSuccess | projectPlanningControllerListProjectsPlanningResponseError)

export const getProjectPlanningControllerListProjectsPlanningUrl = (params: ProjectPlanningControllerListProjectsPlanningParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/planning?${stringifiedParams}` : `/projects/planning`
}

export const projectPlanningControllerListProjectsPlanning = async (params: ProjectPlanningControllerListProjectsPlanningParams, options?: RequestInit): Promise<projectPlanningControllerListProjectsPlanningResponse> => {
  
  return customFetch<projectPlanningControllerListProjectsPlanningResponse>(getProjectPlanningControllerListProjectsPlanningUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProjectPlanningControllerListProjectsPlanningQueryKey = (params?: ProjectPlanningControllerListProjectsPlanningParams,) => {
    return [
    `/projects/planning`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProjectPlanningControllerListProjectsPlanningQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerListProjectsPlanningQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>> = ({ signal }) => projectPlanningControllerListProjectsPlanning(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerListProjectsPlanningQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>>
export type ProjectPlanningControllerListProjectsPlanningQueryError = void


export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List projects for a partner with planning info
 */

export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List projects for a partner with planning info
 */
export const prefetchProjectPlanningControllerListProjectsPlanningQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 queryClient: QueryClient, params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProjectPlanningControllerListProjectsPlanningSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerListProjectsPlanningQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>> = ({ signal }) => projectPlanningControllerListProjectsPlanning(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerListProjectsPlanningSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>>
export type ProjectPlanningControllerListProjectsPlanningSuspenseQueryError = void


export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List projects for a partner with planning info
 */

export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new project in draft status under the given partner. Used by the new Production Planning UI. Mirrors the admin-only event-sourced `POST /projects` but is gated by PartnerAccessGuard and forces project_status = "draft" so new projects start in the planning workflow.
 * @summary Create a project (cookie-auth)
 */
export type projectPlanningControllerCreateProjectPlanningResponse201 = {
  data: ProjectPlanningListItemDto
  status: 201
}

export type projectPlanningControllerCreateProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerCreateProjectPlanningResponse403 = {
  data: void
  status: 403
}
    
export type projectPlanningControllerCreateProjectPlanningResponseSuccess = (projectPlanningControllerCreateProjectPlanningResponse201) & {
  headers: Headers;
};
export type projectPlanningControllerCreateProjectPlanningResponseError = (projectPlanningControllerCreateProjectPlanningResponse401 | projectPlanningControllerCreateProjectPlanningResponse403) & {
  headers: Headers;
};

export type projectPlanningControllerCreateProjectPlanningResponse = (projectPlanningControllerCreateProjectPlanningResponseSuccess | projectPlanningControllerCreateProjectPlanningResponseError)

export const getProjectPlanningControllerCreateProjectPlanningUrl = () => {


  

  return `/projects/planning`
}

export const projectPlanningControllerCreateProjectPlanning = async (createProjectPlanningDto: CreateProjectPlanningDto, options?: RequestInit): Promise<projectPlanningControllerCreateProjectPlanningResponse> => {
  
  return customFetch<projectPlanningControllerCreateProjectPlanningResponse>(getProjectPlanningControllerCreateProjectPlanningUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createProjectPlanningDto,)
  }
);}




export const getProjectPlanningControllerCreateProjectPlanningMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,{data: CreateProjectPlanningDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,{data: CreateProjectPlanningDto}, TContext> => {

const mutationKey = ['projectPlanningControllerCreateProjectPlanning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, {data: CreateProjectPlanningDto}> = (props) => {
          const {data} = props ?? {};

          return  projectPlanningControllerCreateProjectPlanning(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerCreateProjectPlanningMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>>
    export type ProjectPlanningControllerCreateProjectPlanningMutationBody = CreateProjectPlanningDto
    export type ProjectPlanningControllerCreateProjectPlanningMutationError = void

    /**
 * @summary Create a project (cookie-auth)
 */
export const useProjectPlanningControllerCreateProjectPlanning = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,{data: CreateProjectPlanningDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>,
        TError,
        {data: CreateProjectPlanningDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerCreateProjectPlanningMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns a project with planning metadata and its work orders (with container selections, product keys, and metadata).
 * @summary Get project planning detail
 */
export type projectPlanningControllerGetProjectPlanningResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerGetProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerGetProjectPlanningResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerGetProjectPlanningResponseSuccess = (projectPlanningControllerGetProjectPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerGetProjectPlanningResponseError = (projectPlanningControllerGetProjectPlanningResponse401 | projectPlanningControllerGetProjectPlanningResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerGetProjectPlanningResponse = (projectPlanningControllerGetProjectPlanningResponseSuccess | projectPlanningControllerGetProjectPlanningResponseError)

export const getProjectPlanningControllerGetProjectPlanningUrl = (projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/${projectId}/planning?${stringifiedParams}` : `/projects/${projectId}/planning`
}

export const projectPlanningControllerGetProjectPlanning = async (projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: RequestInit): Promise<projectPlanningControllerGetProjectPlanningResponse> => {
  
  return customFetch<projectPlanningControllerGetProjectPlanningResponse>(getProjectPlanningControllerGetProjectPlanningUrl(projectId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProjectPlanningControllerGetProjectPlanningQueryKey = (projectId?: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams,) => {
    return [
    `/projects/${projectId}/planning`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProjectPlanningControllerGetProjectPlanningQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerGetProjectPlanningQueryKey(projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>> = ({ signal }) => projectPlanningControllerGetProjectPlanning(projectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerGetProjectPlanningQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>>
export type ProjectPlanningControllerGetProjectPlanningQueryError = void


export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params: undefined |  ProjectPlanningControllerGetProjectPlanningParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get project planning detail
 */

export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get project planning detail
 */
export const prefetchProjectPlanningControllerGetProjectPlanningQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 queryClient: QueryClient, projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningQueryOptions(projectId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProjectPlanningControllerGetProjectPlanningSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerGetProjectPlanningQueryKey(projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>> = ({ signal }) => projectPlanningControllerGetProjectPlanning(projectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerGetProjectPlanningSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>>
export type ProjectPlanningControllerGetProjectPlanningSuspenseQueryError = void


export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params: undefined |  ProjectPlanningControllerGetProjectPlanningParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get project planning detail
 */

export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Cookie-auth entry point that updates project metadata (name, code, prefix, dates) via the existing event-sourced ProjectsService. Rejects with 409 unless the project is in draft status or is redrafting (has at least one work order reopened for edit). The hub-side admin PATCH at /projects/:project_id is untouched.
 * @summary Update project metadata (cookie-auth)
 */
export type projectPlanningControllerUpdateProjectPlanningResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerUpdateProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUpdateProjectPlanningResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerUpdateProjectPlanningResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerUpdateProjectPlanningResponseSuccess = (projectPlanningControllerUpdateProjectPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUpdateProjectPlanningResponseError = (projectPlanningControllerUpdateProjectPlanningResponse401 | projectPlanningControllerUpdateProjectPlanningResponse404 | projectPlanningControllerUpdateProjectPlanningResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerUpdateProjectPlanningResponse = (projectPlanningControllerUpdateProjectPlanningResponseSuccess | projectPlanningControllerUpdateProjectPlanningResponseError)

export const getProjectPlanningControllerUpdateProjectPlanningUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/planning`
}

export const projectPlanningControllerUpdateProjectPlanning = async (projectId: string,
    updateProjectPlanningDto: UpdateProjectPlanningDto, options?: RequestInit): Promise<projectPlanningControllerUpdateProjectPlanningResponse> => {
  
  return customFetch<projectPlanningControllerUpdateProjectPlanningResponse>(getProjectPlanningControllerUpdateProjectPlanningUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProjectPlanningDto,)
  }
);}




export const getProjectPlanningControllerUpdateProjectPlanningMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,{projectId: string;data: UpdateProjectPlanningDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,{projectId: string;data: UpdateProjectPlanningDto}, TContext> => {

const mutationKey = ['projectPlanningControllerUpdateProjectPlanning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, {projectId: string;data: UpdateProjectPlanningDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUpdateProjectPlanning(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUpdateProjectPlanningMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>>
    export type ProjectPlanningControllerUpdateProjectPlanningMutationBody = UpdateProjectPlanningDto
    export type ProjectPlanningControllerUpdateProjectPlanningMutationError = void

    /**
 * @summary Update project metadata (cookie-auth)
 */
export const useProjectPlanningControllerUpdateProjectPlanning = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,{projectId: string;data: UpdateProjectPlanningDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>,
        TError,
        {projectId: string;data: UpdateProjectPlanningDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerUpdateProjectPlanningMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Persists the AG Grid column state (visibility, order, pinning, width) for the project planning grid. Shared across all users at the partner and reapplied on page load. Allowed on any project status — column layout is presentational and never affects work-order data. Optimistic concurrency: the client passes the project_column_config_updated_at value from its last GET; the server returns 409 if another user has saved in between.
 * @summary Update project planning grid column layout
 */
export type projectPlanningControllerUpdateProjectColumnConfigResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerUpdateProjectColumnConfigResponseSuccess = (projectPlanningControllerUpdateProjectColumnConfigResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUpdateProjectColumnConfigResponseError = (projectPlanningControllerUpdateProjectColumnConfigResponse401 | projectPlanningControllerUpdateProjectColumnConfigResponse404 | projectPlanningControllerUpdateProjectColumnConfigResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerUpdateProjectColumnConfigResponse = (projectPlanningControllerUpdateProjectColumnConfigResponseSuccess | projectPlanningControllerUpdateProjectColumnConfigResponseError)

export const getProjectPlanningControllerUpdateProjectColumnConfigUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/column-config`
}

export const projectPlanningControllerUpdateProjectColumnConfig = async (projectId: string,
    updateProjectColumnConfigDto: UpdateProjectColumnConfigDto, options?: RequestInit): Promise<projectPlanningControllerUpdateProjectColumnConfigResponse> => {
  
  return customFetch<projectPlanningControllerUpdateProjectColumnConfigResponse>(getProjectPlanningControllerUpdateProjectColumnConfigUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProjectColumnConfigDto,)
  }
);}




export const getProjectPlanningControllerUpdateProjectColumnConfigMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,{projectId: string;data: UpdateProjectColumnConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,{projectId: string;data: UpdateProjectColumnConfigDto}, TContext> => {

const mutationKey = ['projectPlanningControllerUpdateProjectColumnConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, {projectId: string;data: UpdateProjectColumnConfigDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUpdateProjectColumnConfig(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>>
    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationBody = UpdateProjectColumnConfigDto
    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationError = void

    /**
 * @summary Update project planning grid column layout
 */
export const useProjectPlanningControllerUpdateProjectColumnConfig = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,{projectId: string;data: UpdateProjectColumnConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>,
        TError,
        {projectId: string;data: UpdateProjectColumnConfigDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerUpdateProjectColumnConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Transitions a draft project to released status. Assigns the current Bill of Operations version to every draft work order and flips them to "scheduled" status. Sets project_released_by and project_released_at. Rejects with 409 if not in draft status, or 400 if any work order is missing a required container selection.
 * @summary Release a project
 */
export type projectPlanningControllerReleaseProjectResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerReleaseProjectResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerReleaseProjectResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerReleaseProjectResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerReleaseProjectResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerReleaseProjectResponseSuccess = (projectPlanningControllerReleaseProjectResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerReleaseProjectResponseError = (projectPlanningControllerReleaseProjectResponse400 | projectPlanningControllerReleaseProjectResponse401 | projectPlanningControllerReleaseProjectResponse404 | projectPlanningControllerReleaseProjectResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerReleaseProjectResponse = (projectPlanningControllerReleaseProjectResponseSuccess | projectPlanningControllerReleaseProjectResponseError)

export const getProjectPlanningControllerReleaseProjectUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/release`
}

export const projectPlanningControllerReleaseProject = async (projectId: string,
    releaseProjectDto: ReleaseProjectDto, options?: RequestInit): Promise<projectPlanningControllerReleaseProjectResponse> => {
  
  return customFetch<projectPlanningControllerReleaseProjectResponse>(getProjectPlanningControllerReleaseProjectUrl(projectId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      releaseProjectDto,)
  }
);}




export const getProjectPlanningControllerReleaseProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,{projectId: string;data: ReleaseProjectDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,{projectId: string;data: ReleaseProjectDto}, TContext> => {

const mutationKey = ['projectPlanningControllerReleaseProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, {projectId: string;data: ReleaseProjectDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerReleaseProject(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerReleaseProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>>
    export type ProjectPlanningControllerReleaseProjectMutationBody = ReleaseProjectDto
    export type ProjectPlanningControllerReleaseProjectMutationError = void

    /**
 * @summary Release a project
 */
export const useProjectPlanningControllerReleaseProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,{projectId: string;data: ReleaseProjectDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>,
        TError,
        {projectId: string;data: ReleaseProjectDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerReleaseProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Confirms (or clears, with null) the workload category for a product across ALL its work orders in the project — workload category is a property of the product, not the individual work order. Allowed while the project is draft, or for products with a redrafting work order once released. Clearing retains the cleared value for the struck-through re-confirm display.
 * @summary Confirm a product workload category for a project (ENG-608)
 */
export type projectPlanningControllerConfirmProductWorkloadCategoryResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerConfirmProductWorkloadCategoryResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerConfirmProductWorkloadCategoryResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerConfirmProductWorkloadCategoryResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerConfirmProductWorkloadCategoryResponseSuccess = (projectPlanningControllerConfirmProductWorkloadCategoryResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerConfirmProductWorkloadCategoryResponseError = (projectPlanningControllerConfirmProductWorkloadCategoryResponse401 | projectPlanningControllerConfirmProductWorkloadCategoryResponse404 | projectPlanningControllerConfirmProductWorkloadCategoryResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerConfirmProductWorkloadCategoryResponse = (projectPlanningControllerConfirmProductWorkloadCategoryResponseSuccess | projectPlanningControllerConfirmProductWorkloadCategoryResponseError)

export const getProjectPlanningControllerConfirmProductWorkloadCategoryUrl = (projectId: string,
    productId: string,) => {


  

  return `/projects/${projectId}/products/${productId}/workload-category`
}

export const projectPlanningControllerConfirmProductWorkloadCategory = async (projectId: string,
    productId: string,
    confirmProductWorkloadCategoryDto: ConfirmProductWorkloadCategoryDto, options?: RequestInit): Promise<projectPlanningControllerConfirmProductWorkloadCategoryResponse> => {
  
  return customFetch<projectPlanningControllerConfirmProductWorkloadCategoryResponse>(getProjectPlanningControllerConfirmProductWorkloadCategoryUrl(projectId,productId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      confirmProductWorkloadCategoryDto,)
  }
);}




export const getProjectPlanningControllerConfirmProductWorkloadCategoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerConfirmProductWorkloadCategory>>, TError,{projectId: string;productId: string;data: ConfirmProductWorkloadCategoryDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerConfirmProductWorkloadCategory>>, TError,{projectId: string;productId: string;data: ConfirmProductWorkloadCategoryDto}, TContext> => {

const mutationKey = ['projectPlanningControllerConfirmProductWorkloadCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerConfirmProductWorkloadCategory>>, {projectId: string;productId: string;data: ConfirmProductWorkloadCategoryDto}> = (props) => {
          const {projectId,productId,data} = props ?? {};

          return  projectPlanningControllerConfirmProductWorkloadCategory(projectId,productId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerConfirmProductWorkloadCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerConfirmProductWorkloadCategory>>>
    export type ProjectPlanningControllerConfirmProductWorkloadCategoryMutationBody = ConfirmProductWorkloadCategoryDto
    export type ProjectPlanningControllerConfirmProductWorkloadCategoryMutationError = void

    /**
 * @summary Confirm a product workload category for a project (ENG-608)
 */
export const useProjectPlanningControllerConfirmProductWorkloadCategory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerConfirmProductWorkloadCategory>>, TError,{projectId: string;productId: string;data: ConfirmProductWorkloadCategoryDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerConfirmProductWorkloadCategory>>,
        TError,
        {projectId: string;productId: string;data: ConfirmProductWorkloadCategoryDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerConfirmProductWorkloadCategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Confirms the suggested workload category for every unconfirmed product referenced by the project’s non-archived work orders. Already-confirmed products are never overwritten. Scoped by the same lock rules as the single confirm (draft project, or redrafting work orders once released).
 * @summary Apply all suggested workload categories on a project (ENG-608)
 */
export type projectPlanningControllerApplySuggestedWorkloadCategoriesResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerApplySuggestedWorkloadCategoriesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerApplySuggestedWorkloadCategoriesResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerApplySuggestedWorkloadCategoriesResponseSuccess = (projectPlanningControllerApplySuggestedWorkloadCategoriesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerApplySuggestedWorkloadCategoriesResponseError = (projectPlanningControllerApplySuggestedWorkloadCategoriesResponse401 | projectPlanningControllerApplySuggestedWorkloadCategoriesResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerApplySuggestedWorkloadCategoriesResponse = (projectPlanningControllerApplySuggestedWorkloadCategoriesResponseSuccess | projectPlanningControllerApplySuggestedWorkloadCategoriesResponseError)

export const getProjectPlanningControllerApplySuggestedWorkloadCategoriesUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/workload-categories/apply-suggested`
}

export const projectPlanningControllerApplySuggestedWorkloadCategories = async (projectId: string, options?: RequestInit): Promise<projectPlanningControllerApplySuggestedWorkloadCategoriesResponse> => {
  
  return customFetch<projectPlanningControllerApplySuggestedWorkloadCategoriesResponse>(getProjectPlanningControllerApplySuggestedWorkloadCategoriesUrl(projectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getProjectPlanningControllerApplySuggestedWorkloadCategoriesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerApplySuggestedWorkloadCategories>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerApplySuggestedWorkloadCategories>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['projectPlanningControllerApplySuggestedWorkloadCategories'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerApplySuggestedWorkloadCategories>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerApplySuggestedWorkloadCategories(projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerApplySuggestedWorkloadCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerApplySuggestedWorkloadCategories>>>
    
    export type ProjectPlanningControllerApplySuggestedWorkloadCategoriesMutationError = void

    /**
 * @summary Apply all suggested workload categories on a project (ENG-608)
 */
export const useProjectPlanningControllerApplySuggestedWorkloadCategories = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerApplySuggestedWorkloadCategories>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerApplySuggestedWorkloadCategories>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerApplySuggestedWorkloadCategoriesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Releases the work orders still in "draft" on an already-released (redrafting) project — the rows added during a redraft cycle. Assigns the current Bill of Operations, renumbers each factory's Manufacturing Sequence, and flips them "draft" → "scheduled". The project stays "released". Used by the re-release flow. Rejects with 409 if the project is not released, or 400 (MISSING_REQUIRED_FIELDS) if any draft work order is missing a required field.
 * @summary Release draft work orders on a redrafting project
 */
export type projectPlanningControllerReleaseDraftWorkOrdersResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerReleaseDraftWorkOrdersResponseSuccess = (projectPlanningControllerReleaseDraftWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerReleaseDraftWorkOrdersResponseError = (projectPlanningControllerReleaseDraftWorkOrdersResponse400 | projectPlanningControllerReleaseDraftWorkOrdersResponse401 | projectPlanningControllerReleaseDraftWorkOrdersResponse404 | projectPlanningControllerReleaseDraftWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerReleaseDraftWorkOrdersResponse = (projectPlanningControllerReleaseDraftWorkOrdersResponseSuccess | projectPlanningControllerReleaseDraftWorkOrdersResponseError)

export const getProjectPlanningControllerReleaseDraftWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/release-drafts`
}

export const projectPlanningControllerReleaseDraftWorkOrders = async (projectId: string, options?: RequestInit): Promise<projectPlanningControllerReleaseDraftWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerReleaseDraftWorkOrdersResponse>(getProjectPlanningControllerReleaseDraftWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getProjectPlanningControllerReleaseDraftWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['projectPlanningControllerReleaseDraftWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerReleaseDraftWorkOrders(projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerReleaseDraftWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>>
    
    export type ProjectPlanningControllerReleaseDraftWorkOrdersMutationError = void

    /**
 * @summary Release draft work orders on a redrafting project
 */
export const useProjectPlanningControllerReleaseDraftWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerReleaseDraftWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Moves a released project back to draft. Only work orders still in "scheduled" status revert to "draft"; work orders already "in_progress" or "complete" are left untouched. Returns 409 if the project is not in released status.
 * @summary Move a released project back to draft
 */
export type projectPlanningControllerMoveProjectToDraftResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerMoveProjectToDraftResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerMoveProjectToDraftResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerMoveProjectToDraftResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerMoveProjectToDraftResponseSuccess = (projectPlanningControllerMoveProjectToDraftResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerMoveProjectToDraftResponseError = (projectPlanningControllerMoveProjectToDraftResponse401 | projectPlanningControllerMoveProjectToDraftResponse404 | projectPlanningControllerMoveProjectToDraftResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerMoveProjectToDraftResponse = (projectPlanningControllerMoveProjectToDraftResponseSuccess | projectPlanningControllerMoveProjectToDraftResponseError)

export const getProjectPlanningControllerMoveProjectToDraftUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/move-to-draft`
}

export const projectPlanningControllerMoveProjectToDraft = async (projectId: string, options?: RequestInit): Promise<projectPlanningControllerMoveProjectToDraftResponse> => {
  
  return customFetch<projectPlanningControllerMoveProjectToDraftResponse>(getProjectPlanningControllerMoveProjectToDraftUrl(projectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getProjectPlanningControllerMoveProjectToDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['projectPlanningControllerMoveProjectToDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerMoveProjectToDraft(projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerMoveProjectToDraftMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>>
    
    export type ProjectPlanningControllerMoveProjectToDraftMutationError = void

    /**
 * @summary Move a released project back to draft
 */
export const useProjectPlanningControllerMoveProjectToDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerMoveProjectToDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Creates the specified number of work order rows on a draft project, each sharing a Product seeded with the supplied Product Type. When the partner has exactly one factory, it is pre-selected on every new work order. Returns all work orders on the project.
 * @summary Batch add work orders to a project
 */
export type projectPlanningControllerBatchAddWorkOrdersResponse201 = {
  data: ProjectWorkOrderDetailDto[]
  status: 201
}

export type projectPlanningControllerBatchAddWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerBatchAddWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchAddWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchAddWorkOrdersResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerBatchAddWorkOrdersResponseSuccess = (projectPlanningControllerBatchAddWorkOrdersResponse201) & {
  headers: Headers;
};
export type projectPlanningControllerBatchAddWorkOrdersResponseError = (projectPlanningControllerBatchAddWorkOrdersResponse400 | projectPlanningControllerBatchAddWorkOrdersResponse401 | projectPlanningControllerBatchAddWorkOrdersResponse404 | projectPlanningControllerBatchAddWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchAddWorkOrdersResponse = (projectPlanningControllerBatchAddWorkOrdersResponseSuccess | projectPlanningControllerBatchAddWorkOrdersResponseError)

export const getProjectPlanningControllerBatchAddWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders`
}

export const projectPlanningControllerBatchAddWorkOrders = async (projectId: string,
    batchAddWorkOrdersDto: BatchAddWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerBatchAddWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerBatchAddWorkOrdersResponse>(getProjectPlanningControllerBatchAddWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      batchAddWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerBatchAddWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,{projectId: string;data: BatchAddWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,{projectId: string;data: BatchAddWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerBatchAddWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, {projectId: string;data: BatchAddWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchAddWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchAddWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>>
    export type ProjectPlanningControllerBatchAddWorkOrdersMutationBody = BatchAddWorkOrdersDto
    export type ProjectPlanningControllerBatchAddWorkOrdersMutationError = void

    /**
 * @summary Batch add work orders to a project
 */
export const useProjectPlanningControllerBatchAddWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,{projectId: string;data: BatchAddWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>,
        TError,
        {projectId: string;data: BatchAddWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerBatchAddWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Deletes the specified work orders and their associated products from a draft project. Returns remaining work orders.
 * @summary Batch remove work orders from a project
 */
export type projectPlanningControllerBatchRemoveWorkOrdersResponse200 = {
  data: ProjectWorkOrderDetailDto[]
  status: 200
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerBatchRemoveWorkOrdersResponseSuccess = (projectPlanningControllerBatchRemoveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerBatchRemoveWorkOrdersResponseError = (projectPlanningControllerBatchRemoveWorkOrdersResponse401 | projectPlanningControllerBatchRemoveWorkOrdersResponse404 | projectPlanningControllerBatchRemoveWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchRemoveWorkOrdersResponse = (projectPlanningControllerBatchRemoveWorkOrdersResponseSuccess | projectPlanningControllerBatchRemoveWorkOrdersResponseError)

export const getProjectPlanningControllerBatchRemoveWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders`
}

export const projectPlanningControllerBatchRemoveWorkOrders = async (projectId: string,
    batchRemoveWorkOrdersDto: BatchRemoveWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerBatchRemoveWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerBatchRemoveWorkOrdersResponse>(getProjectPlanningControllerBatchRemoveWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      batchRemoveWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerBatchRemoveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,{projectId: string;data: BatchRemoveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,{projectId: string;data: BatchRemoveWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerBatchRemoveWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, {projectId: string;data: BatchRemoveWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchRemoveWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>>
    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationBody = BatchRemoveWorkOrdersDto
    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationError = void

    /**
 * @summary Batch remove work orders from a project
 */
export const useProjectPlanningControllerBatchRemoveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,{projectId: string;data: BatchRemoveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>,
        TError,
        {projectId: string;data: BatchRemoveWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerBatchRemoveWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Applies an array of cell-level updates to work orders on a draft project. Each update targets a work order field (scalar) or a container selection (UUID field). Recalculates Product Codes after container changes.
 * @summary Batch update work order cells
 */
export type projectPlanningControllerBatchUpdateWorkOrdersResponse200 = {
  data: ProjectWorkOrderDetailDto[]
  status: 200
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerBatchUpdateWorkOrdersResponseSuccess = (projectPlanningControllerBatchUpdateWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerBatchUpdateWorkOrdersResponseError = (projectPlanningControllerBatchUpdateWorkOrdersResponse400 | projectPlanningControllerBatchUpdateWorkOrdersResponse401 | projectPlanningControllerBatchUpdateWorkOrdersResponse404 | projectPlanningControllerBatchUpdateWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchUpdateWorkOrdersResponse = (projectPlanningControllerBatchUpdateWorkOrdersResponseSuccess | projectPlanningControllerBatchUpdateWorkOrdersResponseError)

export const getProjectPlanningControllerBatchUpdateWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders/batch`
}

export const projectPlanningControllerBatchUpdateWorkOrders = async (projectId: string,
    batchUpdateWorkOrdersDto: BatchUpdateWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerBatchUpdateWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerBatchUpdateWorkOrdersResponse>(getProjectPlanningControllerBatchUpdateWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      batchUpdateWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerBatchUpdateWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,{projectId: string;data: BatchUpdateWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,{projectId: string;data: BatchUpdateWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerBatchUpdateWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, {projectId: string;data: BatchUpdateWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchUpdateWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>>
    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationBody = BatchUpdateWorkOrdersDto
    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationError = void

    /**
 * @summary Batch update work order cells
 */
export const useProjectPlanningControllerBatchUpdateWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,{projectId: string;data: BatchUpdateWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>,
        TError,
        {projectId: string;data: BatchUpdateWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerBatchUpdateWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Archives the submitted work orders that are in `scheduled` or `redrafting` status, removing them from active planning views without deleting any data. Work orders in any other status (in_progress, complete, draft, already archived) are left untouched and returned in `skipped`. Each archive is recorded in the audit trail.
 * @summary Archive work orders on a project
 */
export type projectPlanningControllerArchiveWorkOrdersResponse200 = {
  data: ArchiveWorkOrdersResultDto
  status: 200
}

export type projectPlanningControllerArchiveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerArchiveWorkOrdersResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerArchiveWorkOrdersResponseSuccess = (projectPlanningControllerArchiveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerArchiveWorkOrdersResponseError = (projectPlanningControllerArchiveWorkOrdersResponse401 | projectPlanningControllerArchiveWorkOrdersResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerArchiveWorkOrdersResponse = (projectPlanningControllerArchiveWorkOrdersResponseSuccess | projectPlanningControllerArchiveWorkOrdersResponseError)

export const getProjectPlanningControllerArchiveWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders/archive`
}

export const projectPlanningControllerArchiveWorkOrders = async (projectId: string,
    archiveWorkOrdersDto: ArchiveWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerArchiveWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerArchiveWorkOrdersResponse>(getProjectPlanningControllerArchiveWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      archiveWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerArchiveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,{projectId: string;data: ArchiveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,{projectId: string;data: ArchiveWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerArchiveWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, {projectId: string;data: ArchiveWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerArchiveWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerArchiveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>>
    export type ProjectPlanningControllerArchiveWorkOrdersMutationBody = ArchiveWorkOrdersDto
    export type ProjectPlanningControllerArchiveWorkOrdersMutationError = void

    /**
 * @summary Archive work orders on a project
 */
export const useProjectPlanningControllerArchiveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,{projectId: string;data: ArchiveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>,
        TError,
        {projectId: string;data: ArchiveWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerArchiveWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Restores the submitted archived work orders to the active view, recomputing their lifecycle status from start/complete dates and Bill of Operations assignment. Work orders that are not currently archived are returned in `skipped`. Each unarchive is recorded in the audit trail.
 * @summary Unarchive work orders on a project
 */
export type projectPlanningControllerUnarchiveWorkOrdersResponse200 = {
  data: UnarchiveWorkOrdersResultDto
  status: 200
}

export type projectPlanningControllerUnarchiveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUnarchiveWorkOrdersResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerUnarchiveWorkOrdersResponseSuccess = (projectPlanningControllerUnarchiveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUnarchiveWorkOrdersResponseError = (projectPlanningControllerUnarchiveWorkOrdersResponse401 | projectPlanningControllerUnarchiveWorkOrdersResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerUnarchiveWorkOrdersResponse = (projectPlanningControllerUnarchiveWorkOrdersResponseSuccess | projectPlanningControllerUnarchiveWorkOrdersResponseError)

export const getProjectPlanningControllerUnarchiveWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders/unarchive`
}

export const projectPlanningControllerUnarchiveWorkOrders = async (projectId: string,
    unarchiveWorkOrdersDto: UnarchiveWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerUnarchiveWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerUnarchiveWorkOrdersResponse>(getProjectPlanningControllerUnarchiveWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      unarchiveWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerUnarchiveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,{projectId: string;data: UnarchiveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,{projectId: string;data: UnarchiveWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerUnarchiveWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, {projectId: string;data: UnarchiveWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUnarchiveWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>>
    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationBody = UnarchiveWorkOrdersDto
    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationError = void

    /**
 * @summary Unarchive work orders on a project
 */
export const useProjectPlanningControllerUnarchiveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,{projectId: string;data: UnarchiveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>,
        TError,
        {projectId: string;data: UnarchiveWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerUnarchiveWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    